import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './../assets/slices/shouji.png'
import _imports_1 from './../assets/slices/dengji.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "top-header" }, "欢迎使用校外车辆入校预约系统", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "box-item",
        onClick: _cache[0] || (_cache[0] = () => _ctx.$router.push('/pub/apply'))
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("div", { class: "item-icon" }, [
          _createElementVNode("img", { src: _imports_0 })
        ], -1),
        _createElementVNode("div", { class: "item-text" }, "因公来访", -1)
      ]))]),
      _createElementVNode("div", {
        class: "box-item",
        onClick: _cache[1] || (_cache[1] = () => _ctx.$router.push('/pri/apply'))
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("div", { class: "item-icon" }, [
          _createElementVNode("img", { src: _imports_1 })
        ], -1),
        _createElementVNode("div", { class: "item-text" }, "因私来访", -1)
      ]))]),
      _createElementVNode("div", {
        class: "box-item box-item1",
        onClick: _cache[2] || (_cache[2] = () => _ctx.$router.push('/pub/index'))
      }, "预约记录（因公）"),
      _createElementVNode("div", {
        class: "box-item box-item1",
        onClick: _cache[3] || (_cache[3] = () => _ctx.$router.push('/pri/index'))
      }, "预约记录（因私）")
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "tips-msg" }, [
      _createElementVNode("p", null, [
        _createTextVNode(" 1. "),
        _createElementVNode("b", null, "因公来访"),
        _createTextVNode(" 由被访单位审批，预约当日有效，校内停车时长从被访单位授信时长中扣除。 ")
      ]),
      _createElementVNode("p", null, [
        _createTextVNode(" 2. "),
        _createElementVNode("b", null, "因私来访"),
        _createTextVNode(" 由被访人审批，预约当日有效，车辆计时收费。 ")
      ]),
      _createElementVNode("p", null, "3.咨询电话:82205110(雁塔)、89025110(草堂)。")
    ], -1))
  ]))
}